import { useState } from 'react';
import {
    guardarOtrosDocumentosDeEmpleado,
    obtenerDocumentosPorEmpleado,
    eliminarDocumento
} from '../../../services/empleado/empleadoDocumentoService';

// Helper de fechas
const convertirFecha = (f) => {
    if (!f) return null;
    if (Array.isArray(f)) return new Date(f[0], f[1] - 1, f[2]);
    if (typeof f === 'object' && f.year) return new Date(f.year, f.monthValue - 1, f.dayOfMonth);
    if (typeof f === 'string') return new Date(f);
    return new Date(f);
};

export const useFotos = ({ empleadoId, toast, configMap, listas }) => {

    // 1. Estados
    const [fotosList, setFotosList] = useState([]);
    const [fotoData, setFotoData] = useState({ id: null, descripcion: '', fecha: null });
    const [fotoFile, setFotoFile] = useState([]);

    const [loading, setLoading] = useState(false);


    // 2. Modales (Galería y Formulario)
    const [fotosDialog, setFotosDialog] = useState(false);    // Reemplaza a modals.fotos
    const [addFotoDialog, setAddFotoDialog] = useState(false); // Reemplaza a modals.addFoto

    // 3. Carga de Fotos
    const recargarFotos = async (id) => {
        if (!id) { setFotosList([]); return; }

        try {
            const docs = await obtenerDocumentosPorEmpleado(id);

            // Estrategia de Filtrado (Idéntica a tu bloque G anterior)
            const configFoto = listas?.tiposOtrosDocs?.find(c => c.codigo === configMap.FOTOS);
            const ID_FOTO_NUMERICO = configFoto ? configFoto.configuracionDetId : null;

            const misFotos = docs.filter(d => {
                // A. Por ID de configuración numérico (Ideal)
                if (ID_FOTO_NUMERICO && d.tipoDocumentoId === ID_FOTO_NUMERICO) return true;

                // B. Por Referencia de texto "FOTO" (Tu estrategia principal actual)
                if (d.referencia && d.referencia.toUpperCase() === 'FOTO') return true;

                // C. Respaldo hardcoded
                if (d.tipoDocumentoId === 182) return true;

                return false;
            });

            setFotosList(misFotos.map(doc => ({
                id: doc.id,
                descripcion: doc.descripcion,
                fecha: convertirFecha(doc.fechaInicio),
                archivoUrl: doc.url
            })));

        } catch (e) {
            console.error("Error recargando fotos:", e);
        }
    };

    // 4. Acciones
    const openGallery = () => {
        setFotosDialog(true);
    };

    const openNewFoto = () => {
        setFotoData({ id: null, descripcion: '', fecha: null });
        setFotoFile(null);
        setAddFotoDialog(true);
    };

    const saveFoto = async () => {
        if (loading) return;
        if (!empleadoId) return;

        if (!fotoFile) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar una imagen.' });
            return;
        }

        const payload = {
            id: fotoData.id,
            // Usamos FORM_FOTOS si existe, sino FOTOS (para asegurar compatibilidad)
            codigoTipoDocumento: configMap.FORM_FOTOS || configMap.FOTOS,
            referenciaDetalle: 'FOTO', // Clave para encontrarlas luego
            descripcion: fotoData.descripcion,
            fechaInicio: fotoData.fecha ? fotoData.fecha.toISOString().split('T')[0] : new Date().toISOString().split('T')[0]
        };

        try {
            setLoading(true);
            await guardarOtrosDocumentosDeEmpleado(empleadoId, payload, fotoFile);
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Foto subida correctamente.' });

            setAddFotoDialog(false);
            setFotoData({ id: null, descripcion: '', fecha: null });
            setFotoFile(null);

            await recargarFotos(empleadoId);

        } catch (e) {
            console.error(e);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al subir foto.' });
        } finally {
            setLoading(false);
        }
    };

    const deleteFoto = async (rowData) => {
        if (!window.confirm(`¿Eliminar la foto "${rowData.descripcion}"?`)) return;

        try {
            await eliminarDocumento(rowData.id);
            toast.current.show({ severity: 'success', summary: 'Eliminado', detail: 'Foto eliminada.' });

            // Actualización optimista
            setFotosList(prev => prev.filter(foto => foto.id !== rowData.id));
        } catch (error) {
            console.error("Error borrando foto:", error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo borrar.' });
        }
    };

    return {
        fotosList,
        fotoData,
        setFotoData,
        fotoFile,
        setFotoFile,
        fotosDialog,
        setFotosDialog,
        addFotoDialog,
        setAddFotoDialog,
        recargarFotos,
        openGallery,
        openNewFoto,
        saveFoto,
        deleteFoto,
        setFotosList,
        loading
    };
};